import { Component, Host, h, Prop, Element } from '@stencil/core';
import { StoryblokService } from '../../services';
import { remCalc } from '../../style';
import { ButtonAppearance } from '../rcm-button/rcm-button.types';
import { RcmImageProp } from '../rcm-image/rcm-image.types';
import { Multilink } from '../types/link.types';

@Component({
  tag: 'rcm-banner',
  styleUrl: 'rcm-banner.scss',
  shadow: true,
})
export class RcmBanner {
  @Element() el: HTMLElement;

  @Prop() headline: string;

  @Prop() subline: string;

  @Prop() linkText: string;

  @Prop() link: string;

  @Prop() linkDescription: string;

  @Prop({ mutable: true }) imageSrc: RcmImageProp | string;

  @Prop() dark = true;

  @Prop() backgroundPosition: string;

  @Prop() parentComponent: string;

  @Prop() secondaryButtonLabel: string;

  @Prop() secondaryButtonLink: string | Multilink;

  @Prop() secondaryButtonAppearance?: ButtonAppearance;

  componentWillLoad() {
    if (this.imageSrc) {
      const regexDimensions = /\/m\/\d+x\d+/;

      const parsedImgSrc = StoryblokService.parseImageSrc(this.imageSrc, this.el).replace(regexDimensions, '/m/1200x200');

      // Note: parentheses are reserved characters in css, so they should be escaped
      this.imageSrc = parsedImgSrc.replaceAll('(', '%28').replaceAll(')', '%29');
    }
  }

  render() {
    const containerStyles = {};
    if (this.imageSrc) {
      // eslint-disable-next-line dot-notation
      containerStyles['backgroundImage'] = `url(${this.imageSrc})`;
      // eslint-disable-next-line dot-notation
      containerStyles['backgroundSize'] = 'cover';
      // eslint-disable-next-line dot-notation
      containerStyles['backgroundPosition'] = this.backgroundPosition || 'center';
      // eslint-disable-next-line dot-notation
      containerStyles['min-height'] = `${remCalc(408)}rem`;
    }
    const btnAppearance = this.secondaryButtonAppearance ?? ButtonAppearance.PRIMARY_GREY;

    return (
      <Host>
        <div class={{ banner: true, overlay: !this.dark }} style={containerStyles}>
          {this.headline && (
            <rcm-headline
              class="headline"
              level={2}
              headline={this.headline}
              bold
              color={this.dark ? 'var(--colors-dark-base)' : 'var(--colors-basic-white)'}
            ></rcm-headline>
          )}
          {this.subline && (
            <rcm-headline
              class="subline"
              level={3}
              headline={this.subline}
              regular
              color={this.dark ? 'var(--colors-dark-light)' : 'var(--colors-basic-white)'}
            ></rcm-headline>
          )}
          <div class="buttons">
            {this.link && this.linkText && (
              <rcm-button
                text={this.linkText}
                link={this.link}
                ariaLabel={this.linkDescription}
                appearance={this.dark ? ButtonAppearance.PRIMARY_GREY : ButtonAppearance.SECONDARY_WHITE}
                parentComponent={this.parentComponent}
              ></rcm-button>
            )}

            {this.secondaryButtonLabel && this.secondaryButtonLink && (
              <rcm-button
                text={this.secondaryButtonLabel}
                link={this.secondaryButtonLink}
                appearance={btnAppearance}
                parentComponent={this.parentComponent}
              ></rcm-button>
            )}
          </div>
        </div>
      </Host>
    );
  }
}
